import { FsBracketemPointsRules } from "db/model/pickemDetails/Bracketem/FsBracketemPointsRules";
import { BracketemPointsRules } from "model/PickemDetails/Bracketem/PointsRules";
import { nonUndefined } from "Utility";

export const mapBracketemPointsRules = (
  fsModel: FsBracketemPointsRules
): BracketemPointsRules | undefined => {
  if (typeof fsModel === "number") {
    return fsModel;
  }

  if (!fsModel.depth) {
    return undefined;
  }

  return {
    depth: nonUndefined(fsModel.depth),
    lowerDepth: !!fsModel.lowerDepth
      ? nonUndefined(fsModel.lowerDepth)
      : undefined,
    grandFinal: fsModel.grandFinal,
  };
};
